var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "login-wrap" },
    [
      _c("div", { staticClass: "login-top" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "ms-login" },
          [
            _c("div", { staticClass: "ms-title" }, [
              _c("img", {
                attrs: { src: require("@/assets/img/kp-logo.png") },
              }),
              _c("label", [_vm._v(_vm._s(_vm.$t("COMMON_PROJECT_NAME")))]),
            ]),
            _c(
              "el-form",
              {
                ref: "login",
                staticClass: "ms-content",
                attrs: {
                  model: _vm.param,
                  rules: _vm.rules,
                  "label-width": "0px",
                },
              },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "item checkAccount",
                    attrs: { prop: "userName" },
                  },
                  [
                    _c("p", { staticClass: "title" }, [
                      _vm._v("Change user name"),
                    ]),
                    _c("el-input", {
                      attrs: { placeholder: _vm.$t("login_new_userName") },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.submitForm()
                        },
                      },
                      model: {
                        value: _vm.param.userName,
                        callback: function ($$v) {
                          _vm.$set(_vm.param, "userName", $$v)
                        },
                        expression: "param.userName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "footer-login" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "login-btn login-item back",
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.backLogin()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("login_btn_back")))]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "login-btn login-item save",
                        attrs: { loading: _vm.loginLoading, type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.submitForm()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("login_btn_confirm")))]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("v-bottom"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "imglogo" }, [
      _c("img", { attrs: { src: require("@/assets/img/loginbg.png") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }